import React, { ReactNode, useCallback } from "react";
import { CheckoutItemsProps } from "../../../../store/modules/checkout/types";
import { Botton } from "../styles";
import { useDispatch } from "react-redux";
import { ProductActionTypes, productData } from "../../../../store/modules/product/types";
import { detailsProduct } from "../../../../store/modules/product/actions";
import { useHistory } from "react-router-dom";

interface IProductImage {
    product: CheckoutItemsProps;
    children: ReactNode;
}

export function ProductImageAction({ product, children }: IProductImage) {
    const dispatch = useDispatch();
    const history = useHistory();

    const handleDetailsProduct = useCallback(
        async (product: productData) => {
            //konsole.log('handleDetailsProduct: ', product);
            switch (product.type) {
                case ProductActionTypes.DETAILS:
                    if (product.products) dispatch(detailsProduct(product.products));
                    history.push(`/produto?id=${product.products?.id}`);
                    break;

                default:
            }
        },
        [history, dispatch],
    );

    return (
        <Botton
            onClick={() => {
                handleDetailsProduct({
                    type: ProductActionTypes.DETAILS,
                    products: product.product,
                })
            }}
        >
            {children}
        </Botton>
    )
}
